export default "__VITE_ASSET__oLgmfc90__"